export const clientSatisfactionGuide = {
  title: "How to use Client Satisfaction",
  intro:
    "This report summarizes client survey and client review ratings so you can track satisfaction, follow-ups, and public review funnel health.",
  goals: [
    "Spot trends in overall satisfaction",
    "Identify technicians who need coaching or recognition",
    "Monitor criteria-level strengths and weaknesses",
    "Track follow-up volume and resolution speed",
    "Understand the public review funnel conversion",
  ],
  steps: [
    "Choose a Start date and End date for the time period you want to review.",
    "Pick a Trend bucket (Day / Week / Month) to control how the trend line groups results.",
    "Click Run report.",
    "If results look empty, expand the date range or confirm client feedback is being collected.",
    "Use Export CSV to share results with your manager team or for coaching discussions.",
  ],
  reading: [
    "Criteria Averages show how each service area is scoring.",
    "Ratings Distribution highlights how many feedback responses land in each star rating.",
    "Follow-up Health shows how many issues were created and how quickly they're resolved.",
    "Public Review Funnel tracks eligible, prompted, and clicked counts.",
    "Satisfaction Trend shows the average rating over time.",
    "Staff Breakdown highlights technician averages and below-4 rates.",
  ],
  actions: [
    "If a technician score is low: Review recent tickets and feedback notes.",
    "If follow-ups are piling up: Adjust staffing or response workflows.",
    "If a criterion is low: Review service timing, front desk process, or training needs.",
    "If the public review funnel is weak: Confirm the review link and messaging.",
  ],
  note:
    "All dates and grouping use your salon's timezone from the Salon Setup Wizard.",
};

export const clientSatisfactionTooltips = {
  start_date:
    "Beginning of the date range for feedback included in the report (salon local time).",
  end_date:
    "End of the date range for feedback included in the report (salon local time).",
  trend_bucket:
    "Controls how the satisfaction trend is grouped (Day, Week, or Month). Use Week or Month for clearer patterns.",
  run_report: "Refresh the report using the filters above.",
  reset_filters: "Clear filters back to the default date range.",
  criteria_averages:
    "Average scores for each feedback criterion (salon, reception, service, staff, and online booking).",
  ratings_distribution:
    "Counts of overall ratings from 1 to 5 stars.",
  followup_health:
    "Tracks how many follow-ups were created and how many are still open.",
  public_review_funnel:
    "Tracks how many clients were eligible, prompted, and clicked the public review ask.",
  satisfaction_trend:
    "Average overall rating over time. Use this to see whether satisfaction is improving or declining.",
  staff_breakdown:
    "Average feedback results by staff/technician.",
  export_csv: "Download this section's data to CSV for sharing or coaching.",
};
